console.log('All environment variables:', {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL,
  REACT_APP_SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ? 'exists' : 'missing'
}); 